import "@partials/areas/areas";
import "@partials/UI/form/modules/recaptcha/recaptchaLoaderForStaticForm"; // загружаем Google reCAPTCHA
import { commonModules, commonExternalResources } from "@scripts/modules/lazy/commonModules";

// Внешние ресурсы для страницы index
const indexResources = [
    ...commonExternalResources,
];

// Модули страницы index
const indexModules = [
    ...commonModules,
    // Дополнительные модули для главной страницы (без зависимостей)
    () => import(/* webpackChunkName: "video" */ "@partials/call-to-action/video/video.js"),
];

// Запуск ленивой инициализации
import(/* webpackChunkName: "lazy-init" */ "@scripts/modules/lazy/lazy-init.js")
    .then(({ initializeModules }) => {
        initializeModules(indexModules, indexResources);
    })
    .catch(error => {
        console.error("❌ Не удалось загрузить систему инициализации:", error);
    });
